import React from 'react'
import OnVisible from 'react-on-visible'
import classNames from 'classnames/bind'
import { Section, Image, TaglineTitleContent, PrimarySecondaryButtons } from 'newComponents'
import stars from '../../images/_defaultStars/static-stars-legacy.jpeg'

import './styles.scss'

const TwoColsImageText = (props) => {
  const { data } = props
  const { primary, slice_type: sliceType } = data
  const {
    content,
    primary_cta_link: ctaLinkOne,
    primary_cta_text: ctaTextOne,
    secondary_cta_link: ctaLinkTwo,
    secondary_cta_text: ctaTextTwo,
    image,
    image_left: imageLeft,
    tagline,
    title,
    new_rendering: newRendering,
    overflow_background_image: bgOverflowImg,
    light_background: lightBg
  } = primary

  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html
  const taglineHtml = tagline?.html
  const hasImage = image?.url
  const hasPrimaryCta = ctaLinkOne?.url && ctaTextOne?.text
  const hasSecondaryCta = ctaLinkTwo?.url && ctaTextTwo?.text
  const imageAlign = imageLeft ? 'left-align' : ''

  const isHeader = sliceType === 'two_cols_image_text'

  const className = classNames({
    'two-cols-img-text': true,
    'new-rendering': newRendering,
    'overflow-bg': bgOverflowImg,
    'light-bg': lightBg
  })

  return (
    <div className={className}>
      <OnVisible className={`two-cols-img-text ${imageAlign}`}>
        <Section className="two-cols-img-text-container" bgImage={!newRendering && !lightBg ? stars : null}>
          <div>
            <TaglineTitleContent tagline={taglineHtml} content={contentHtml} title={titleHtml} isHeader={isHeader} />
            {(hasPrimaryCta || hasSecondaryCta) && (
              <PrimarySecondaryButtons
                primaryText={ctaTextOne.text}
                primaryLink={ctaLinkOne.url}
                secondaryText={ctaTextTwo.text}
                secondaryLink={ctaLinkTwo.url}
              />
            )}
          </div>
          {hasImage && <Image className="two-cols-img-text-image" image={image} />}
        </Section>
      </OnVisible>
    </div>
  )
}

export default TwoColsImageText
